import { getTable as dbGetTable } from ":shared/database/get-table";
import type { DeckIdentifiable } from "../model";

export const TABLE = "decks";
export const getTable = () => dbGetTable<DeckIdentifiable, string>(TABLE);

export interface Filters {
	id?: string | string[];
}
export const QUERY_KEYS = {
	records: (filters: Filters = {}) => [TABLE, filters],
};
